<div class="flex flex-col gap-5">
  @for (note of notes(); track note.version) {
    <section>
      <h3 class="text-xs font-medium uppercase tracking-wide text-on-surface-variant mb-2">
        Verze z {{ note.version | date: 'd. M. y' }}
      </h3>
      <ul class="flex flex-col gap-2.5">
        @for (item of note.items; track $index) {
          <li class="flex items-start gap-2.5 text-sm leading-relaxed">
            <span
              class="mt-0.5 w-20 shrink-0 rounded-full py-0.5 text-center text-xs leading-tight"
              [class]="kindClasses[item.kind]"
            >
              {{ kindLabels[item.kind] }}
            </span>
            <div>
              {{ item.text }}
              @if (item.feature; as feature) {
                @for (label of tierLabels(feature); track label) {
                  <span
                    class="ml-1 inline-block rounded-full border border-outline-variant px-2 text-xs leading-tight text-on-surface-variant"
                  >
                    {{ label }}
                  </span>
                }
              }
              <!-- A link into a feature the school lacks would end at the license guard. -->
              @if (item.link && !(item.feature && licenseState.featureUnavailable(item.feature))) {
                <a
                  [routerLink]="item.link.path"
                  (click)="onLinkClick($event)"
                  class="ml-1 whitespace-nowrap text-primary hover:underline"
                >
                  {{ item.link.label }} →
                </a>
              }
            </div>
          </li>
        }
      </ul>
    </section>
  }
</div>
